<template>
    <span class="number-font">{{ chargeDisplay }}</span>
</template>

<script>
export default {
    name: 'MonthChargeHandler',

    props: {
        charge: {
            type: Object,
            required: true,
        },
        reportUnit: {
            type: String,
            required: false,
            default: '',
        },
    },

    computed: {
        chargeDisplay() {
            const value =
                this.reportUnit === 'euros'
                    ? this.charge.amount
                    : this.charge.duration
            return value > 0 ? value.toFixed(this.fractionDigits) : '-'
        },

        fractionDigits() {
            return this.reportUnit === 'euros' ? 0 : 2
        },
    },
}
</script>

<style scoped></style>
